import React from 'react';

import { DrawerContent as ChakraDrawerContent, Flex } from '@chakra-ui/react';
import styled from '@emotion/styled';

import { primaryDrawerWidth } from '.';

const StyledDrawerContent = styled(ChakraDrawerContent)`
  height: ${(props) => (props.height ? props.height : `calc(100% - 40px)`)};
  width: ${(props) => (props.width ? props.width : `${primaryDrawerWidth}px`)};

  background-color: white;
  border-radius: 8px 8px 0px 0px;

  margin-left: ${(props) => (props.marginLeft ? props.marginLeft : `auto`)};
  margin-right: ${(props) => (props.marginRight ? props.marginRight : `40px`)};

  transition: width 0.375s;
`;

export const DrawerContent = ({ children, ...props }) => (
  <StyledDrawerContent {...props} data-testid="bottom-drawer">
    {' '}
    {children}{' '}
  </StyledDrawerContent>
);

export const DrawerContentSecondary = ({ children, ...props }) => (
  <StyledDrawerContent borderRadius="8px 8px 0px 0px !important" p={1} {...props}>
    <Flex flexDir="column" borderRadius="8px" borderWidth="4px" h="100%" borderColor="neutral.EBEFF3">
      {children}
    </Flex>
  </StyledDrawerContent>
);
